module.exports = __webpack_public_path__ + "6e1d177d4afb5d77ef4f117208b34547.svg";